module.exports = __webpack_public_path__ + "static/media/right-arrow-restaurant.593c9ec2.svg";